import React, { useEffect } from "react";
import { images } from "../../constants";
import Suggestionbox from "../Suggestionbox";
import Reportbox from "../Reportbox";
import Reportselectezibox from "../Report to selectezi";
import StarRateIcon from "@mui/icons-material/StarRate";
import StoreIcon from "@mui/icons-material/Store";
import RatingModel from "../ProductsRating";
import { useState } from "react";
import ShareIcon from "@mui/icons-material/Share";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import StreamIcon from "@mui/icons-material/Stream";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import { Col, Row } from "react-bootstrap";
import Connectmodal from "../Connect_modal";
import FiberManualRecordSharpIcon from "@mui/icons-material/FiberManualRecordSharp";
import { useGetUserInfoQuery } from "../../features/user/userApiSlice";
import {
  useGetVendorLikeDislikeQuery,
  usePostLikeDislikeMutation,
  usePostSuggestionMutation,
} from "../../features/shop/shopApiSlice";
import { SuccessNotify, FailedNotify } from "../../constants/tostify";
import { useSelector } from "react-redux";
import CashModal from "../cash-deliveryModal/CashModal";
import QRCode from "qrcode.react";
import "./UserShopProfile.css";
import { getAsset } from "../../helpers/helper";
import { useLocation } from "react-router-dom";
import noImagePlaceholder from "../../assets/images/dummy/no_image_placeholder.png";
import Desmodal from "../Des_Modal";
import { useNavigate } from "react-router-dom";
import ConnectProfileModal from "../Connect_Modal_Buy";

const hasShopImage = (image) => {
  if (!image) return false;
  if (Array.isArray(image)) {
    return image.flat(Infinity).some((item) => {
      if (!item) return false;
      if (typeof item === "string") return item.trim().length > 0;
      if (typeof item === "object") {
        return Boolean(item.url || item.path || item.src || item.image);
      }
      return false;
    });
  }
  if (typeof image === "string") return image.trim().length > 0;
  if (typeof image === "object") {
    return Boolean(image.url || image.path || image.src || image.image);
  }
  return false;
};

const UserShopProfile = ({
  setCreateShop,
  lgShowreport,
  shopid,
  handleLikeDislike,
  shopData,
  id,
  createShop,
}) => {
  const navigate = useNavigate();

  const { name } = useSelector((state) => state.user);
  const [lgShow, setLgShow] = useState(false);
  const [connectbuyModal, setConnectbuyModal] = useState(false);
  const [lgshowreport, setLgShowreport] = useState(false);
  const [active, setActive] = useState("");
  const [showconnect, setShowconnect] = useState(false);
  const [showmodal, setShowmodal] = useState(false);
  const [tLike, setTLike] = useState(null);
  const [tDislike, setTDislike] = useState(null);
  const [status, setStatus] = useState(null);
  const closemodal = () => setShowmodal(false);
  const [cashmdl, setCashmdl] = useState(false);
  const [showqr, setShowqr] = useState(0);
  const handleClose = () => setCashmdl(false);
  const handleShow = () => setCashmdl(true);
  const location = useLocation();
  const isCompanyRoute =
    location.pathname.includes("/find-jobs-online") ||
    location.pathname.includes("/user-peronal-property") ||
    location.pathname.includes("/user-bussines-property");

  const [isloading, setIsloading] = useState(false);
  const [togle, setoggle] = useState(false);
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setImgError(false);
  }, [shopData?.image, shopid]);
  const [suggestion, setSuggestion] = useState({
    vendorid: shopid,
    userid: name._id,
    username: name.fullname,
    useremail: name.email,
    role: "",
    imageUrl: "",
    message: "",
  });
  const [desshow, setDesshow] = useState(false);

  let shop = "Shop";
  location.pathname === `/find-jobs-online/${id}`
    ? (shop = "Company")
    : (shop = "Shop");
  const { data: userInfoRes } = useGetUserInfoQuery(name?._id, {
    skip: !name?._id,
  });
  const { data: likeDislikeRes, refetch: refetchLikeDislike } =
    useGetVendorLikeDislikeQuery(shopid, { skip: !shopid });
  const [postLikeDislike] = usePostLikeDislikeMutation();
  const [postSuggestionMutation] = usePostSuggestionMutation();

  useEffect(() => {
    if (userInfoRes?.data?.User?.imageUrl) {
      setSuggestion((prevState) => ({
        ...prevState,
        imageUrl: userInfoRes.data.User.imageUrl,
      }));
    }
  }, [userInfoRes]);

  useEffect(() => {
    if (active !== "") {
      likeSystem();
    }
  }, [active]);

  const handleClosedes = () => setDesshow(false);
  const handleShowdes = () => setDesshow(true);

  const suggestHandel = (event) => {
    setSuggestion((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const suggestPost = async (e) => {
    e.preventDefault();
    try {
      await postSuggestionMutation(suggestion).unwrap();
      SuccessNotify("Suggestion Data is posted successfully");
      setLgShow(false);
    } catch (err) {
      FailedNotify("Failed to  post suggestion Data");
    }
  };

  const handleCloseconnect = () => setShowconnect(false);
  const [selectezireport, setSelectezireport] = useState(false);
  const [smShow, setSmShow] = useState(0);
  const [showFullAddress, setShowFullAddress] = useState(false);

  useEffect(() => {
    setShowqr(1);
  }, [setShowqr]);

  const handleClick = (action) => {
    const newState = {
      userid: name._id,
      vendorid: shopid,
      likedislike: action,
    };

    setStatus(action); // Optimistically update the status immediately
    setActive(action);

    likeSystem(newState); // Make the API call
  };

  const likeSystem = async (newState) => {
    try {
      const res = await postLikeDislike(newState).unwrap();
      if (res.success) {
        refetchLikeDislike();
      }
    } catch (error) {
      console.error("Error updating like/dislike:", error);
      setStatus(null);
    }
  };

  useEffect(() => {
    if (
      likeDislikeRes &&
      likeDislikeRes.success &&
      likeDislikeRes.data.length > 0
    ) {
      const item = likeDislikeRes.data[0];
      setTLike(item.Tlike);
      setTDislike(item.Tdislike);
      if (item.likedislike && item.likedislike.length > 0) {
        setStatus(item.likedislike[0].status);
      }
    }
  }, [likeDislikeRes]);

  return (
    <>
      <ConnectProfileModal
        connectbuyModal={connectbuyModal}
        setConnectbuyModal={setConnectbuyModal}
        shopData={shopData}
      />
      <Desmodal
        desshow={desshow}
        handleClosedes={handleClosedes}
        des={shopData?.description}
      />
      <CashModal cashmdl={cashmdl} handleClose={handleClose} />

      <Connectmodal
        showconnect={showconnect}
        handleCloseconnect={handleCloseconnect}
      />
      <Suggestionbox
        lgShow={lgShow}
        setLgShow={setLgShow}
        suggestion={suggestion}
        suggestHandel={suggestHandel}
        suggestPost={suggestPost}
      />
      <RatingModel setSmShow={setSmShow} smShow={smShow} shopid={shopid} />
      <Reportbox
        setCreateShop={setCreateShop}
        shopid={shopid}
        lgshowreport={lgshowreport}
        setLgShowreport={setLgShowreport}
        createShop={createShop}
      />
      <Reportselectezibox
        selectezireport={selectezireport}
        setSelectezireport={setSelectezireport}
        shopid={shopid}
      />
      <div className="user-shop-profile p-3">
        <div className="relate_div">
          <div className="d-flex availble_bt0n">
            <FiberManualRecordSharpIcon
              style={{ color: "rgb(106 235 64)", fontSize: "19px" }}
            />
            <span>Available</span>
          </div>

          <img
            className="w-100 shop-profile-img"
            src={
              imgError || !hasShopImage(shopData?.image)
                ? noImagePlaceholder
                : getAsset(shopData?.image)
            }
            alt={
              imgError || !hasShopImage(shopData?.image)
                ? "No Image found"
                : isCompanyRoute
                  ? shopData?.companyname || "Company"
                  : shopData?.shopname || "Shop"
            }
            crossOrigin={
              imgError || !hasShopImage(shopData?.image)
                ? undefined
                : "anonymous"
            }
            onError={() => setImgError(true)}
          />
        </div>

        <div className="box-container pb-1 mt-2">
          <Row className="user-shop-profile-details">
            <Col lg="9" className="user-shop-profile-info">
              <div className="pt-2 pb-1">
                <h4 className="shop-Profile-font mb-0">
                  {isCompanyRoute ? shopData?.companyname : shopData?.shopname}
                </h4>
                <div className="d-flex">
                  <div>
                    {" "}
                    <p className="shop-profile-para mb-0">
                      {shopData?.description?.slice(0, 25)}
                    </p>
                  </div>
                  <div>
                    {" "}
                    <p className="shop-profile-para mb-0 ">
                      {shopData?.description?.length > 25 && (
                        <span
                          onClick={handleShowdes}
                          className="mb-0 cursor_P font_11 text-dark"
                          style={{ marginTop: "3px" }}
                        >
                          &nbsp;<b>ReadMore...</b>
                        </span>
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center pb-2">
                <img className="w-img" src={images.Building} alt="image" />
                <p className="mb-0 font-sm pt-1 pb-1 ps-2">
                  {(() => {
                    const address = isCompanyRoute
                      ? shopData?.companyaddress
                      : shopData?.shopaddress;

                    if (!address) return "No Address";
                    if (address.length <= 50) return address;

                    return (
                      <>
                        {showFullAddress
                          ? address
                          : address.slice(0, 50) + "..."}
                        <span
                          className="text-primary ms-1 font_11 text-dark"
                          onClick={() => setShowFullAddress(!showFullAddress)}
                          style={{ cursor: "pointer", fontWeight: "bold" }}
                        >
                          {showFullAddress ? "Show Less" : "Read More"}
                        </span>
                      </>
                    );
                  })()}
                </p>
              </div>
              <div className="d-flex align-items-center">
                <StoreIcon style={{ color: "#434343" }} />
                <p className="mb-0 font-sm pt-1 pb-1 ps-2">
                  {isCompanyRoute
                    ? shopData?.marketplace
                    : shopData?.marketPlace}
                </p>
              </div>
            </Col>
            <Col lg="3" className="user-shop-profile-qr">
              <div className="d-flex justify-content-end">
                {showqr == 1 && (
                  <QRCode
                    size={256}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={`https://selectezi.com/${shopid}`}
                    viewBox={`0 0 256 256`}
                  />
                )}
              </div>
            </Col>
          </Row>
        </div>
        {/* details */}
        <div className="pt-2 pb-2">
          <div>
            <div
              className="d-flex align-items-center cursor_P"
              onClick={() => setSmShow(1)}
            >
              <StarRateIcon style={{ color: "#FFE507" }} />
              <p className="mb-0 font-sm pt-1 pb-1 ps-2 mt-1">
                Rate This {shop}{" "}
                {shopData?.ratings !== undefined && shopData?.ratings > 0
                  ? `(${Number(shopData?.ratings).toFixed(1)} / 5)`
                  : ""}
              </p>
            </div>

            <div className="d-flex">
              <div className="w-100 user-shop-profile-actions">
                <div
                  className="d-flex align-items-center pt-2 pb-2 cursor_P"
                  onClick={() => handleClick("like")}
                >
                  {status === "like" ? (
                    <img
                      className="w-img cursor_P"
                      src={images.Activelike}
                      alt="image"
                    />
                  ) : (
                    <img className="w-img" src={images.Liked} alt="image" />
                  )}

                  <p className="mb-0 font-sm ps-2">
                    Like This {shop}
                    <span style={{ fontSize: "12px" }}>
                      (Liked by {tLike})
                    </span>{" "}
                  </p>
                </div>
                <div
                  className="d-flex align-items-center pt-2 pb-1 cursor_P pb-2"
                  onClick={() => handleClick("dislike")}
                >
                  {status === "dislike" ? (
                    <img
                      className="w-img"
                      src={images.ActiveDislike}
                      alt="image"
                    />
                  ) : (
                    <img className="w-img" src={images.DisLiked} alt="image" />
                  )}

                  <p className="mb-0 font-sm ps-2">
                    Dislike This {shop}
                    <span style={{ fontSize: "12px" }}>
                      (Disliked by {tDislike})
                    </span>
                  </p>
                </div>

                <div className="d-flex align-items-center pb-2">
                  <ShareIcon />
                  <p
                    className="mb-0 font-sm pt-1 pb-1 ps-2 pointer_clsss"
                    onClick={() => setConnectbuyModal(true)}
                  >
                    Send connection request
                  </p>
                </div>

                {location.pathname.includes("/find-jobs-online") ? (
                  ""
                ) : (
                  <>
                    <div
                      className="d-flex align-items-center cursor_P user-shop-profile-action"
                      onClick={() => setLgShow(true)}
                    >
                      <img src={images.suggest} alt="logo" />
                      <p className="mb-0 font-sm pt-1 pb-1 ps-2">
                        Give suggestion to Shop owner
                      </p>
                    </div>
                    <div className="d-flex align-items-center pb-2 user-shop-profile-action">
                      <img src={images.report} alt="logo" width="14%" />
                      <p
                        className="mb-0 font-sm pt-1 pb-1 ps-2 cursor_P mt-2"
                        onClick={() => setLgShowreport(true)}
                      >
                        Report to Shop owner
                      </p>
                    </div>
                  </>
                )}

                <div className="d-flex align-items-center pb-2 user-shop-profile-action">
                  <ReportProblemIcon style={{ color: "red" }} />
                  <p
                    className="mb-0 font-sm pt-1 pb-1 ps-2 cursor_P"
                    onClick={() => setSelectezireport(true)}
                  >
                    Report to Selectezi
                  </p>
                </div>
                {location.pathname.includes("/find-jobs-online") ? (
                  ""
                ) : (
                  <div className="d-flex align-items-center cursor_P user-shop-profile-action">
                    <img src={images.live} alt="logo" />
                    <p className="mb-0 font-sm pt-1 pb-1 ps-2">
                      Join Shop owner Live stream
                    </p>
                  </div>
                )}

                <div className="user-shop-profile-consultancy">
                  <button
                    type="button"
                    onClick={() =>
                      navigate(
                        `/view-consultancy-services-profile/${shopid}/${shopData?.userid}`,
                      )
                    }
                    className="consultancy-btn bg-blue text-white rounded"
                  >
                    View Consultancy Services
                  </button>
                </div>

                {/* <div
                  className="d-flex align-items-center cursor_P"
                  onClick={handleShow}
                >
                  <img className="width10" src={images?.CASH} alt="logo" />
                  <p className="mb-0 font-sm pt-1 pb-1 ps-2">
                    Payment and delivery
                  </p>
                </div> */}
              </div>
              {/* <div className="div-width-1">
                <img className="w-100" src={images.Maps} />
              </div> */}
            </div>
          </div>
        </div>
        {/* btns */}
      </div>
    </>
  );
};

export default UserShopProfile;